<template>
  <a-modal
    ref="authRole"
    :title="$t('views.systemUser.authRole.title')"
    :width="900"
    :visible="visible"
    :confirm-loading="submitLoading"
    @cancel="close"
    @ok="confirm"
  >

    <div class="page-header-content">
      <a-card :bordered="false" class="content">
        <a-table
          :loading="loading"
          :size="tableSize"
          rowKey="id"
          :columns="displayColumns"
          :data-source="list"
          :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          :scroll="{ y: tableHeight }"
          :pagination="false"
          :bordered="tableBordered">
          <span slot="createTime" slot-scope="text, record">
            {{ parseTime(record.createTime) }}
          </span>
        </a-table>
      </a-card>
    </div>
  </a-modal>
</template>

<script>

import { getAuthRole, updateAuthRole } from '@/api/system/user'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'AuthRole',
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      user: {},
      selectedRowKeys: [],
      selectedRows: [],
      tableHeight: document.documentElement.scrollHeight - 500 + 'px',
      roleIds: [],
      loading: false,
      submitLoading: false,
      visible: false,
      columns: [
        {
          title: '',
          dataIndex: 'id',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '',
          dataIndex: 'roleName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '',
          dataIndex: 'roleKey',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          align: 'center'
        }
      ]
    }
  },
  computed: {
    displayColumns () {
      const titleKeyByDataIndex = {
        id: 'views.systemUser.authRole.column.id',
        roleName: 'views.systemUser.authRole.column.roleName',
        roleKey: 'views.systemUser.authRole.column.roleKey',
        createTime: 'views.systemUser.authRole.column.createTime'
      }
      return this.columns.map(col => {
        const key = titleKeyByDataIndex[col.dataIndex]
        return {
          ...col,
          title: key ? this.$t(key) : col.title
        }
      })
    }
  },
  methods: {
    getList (userId) {
      this.loading = true
      getAuthRole(userId).then(res => {
        if (res.code == 20001) {
          this.list = res.data.roles
          this.user = res.data.user
          this.$nextTick(() => {
            const roleIds = (res.data.roles || []).filter(item => item.flag).map(item => item.id)
            this.roleIds = roleIds
            this.selectedRowKeys = roleIds
          })
          this.loading = false
        }
      })
    },
    close () {
      this.visible = false
      this.selectedRowKeys = []
      this.selectedRows = []
    },
    handleAuthRole (row) {
      this.visible = true
      this.getList(row.id)
    },
    confirm () {
      this.submitLoading = true
      updateAuthRole({ userId: this.user.id, roleIds: this.roleIds }).then(res => {
        this.$message.success(res.message)
        this.visible = false
        this.$emit('ok')
      }).finally(() => {
        this.submitLoading = false
      })
    },
    onSelectChange (selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
      this.roleIds = selectedRowKeys
    }
  }
}
</script>
